import { render, staticRenderFns } from "./IntegratedUseCases.vue?vue&type=template&id=64d27714&scoped=true&"
import script from "./IntegratedUseCases.vue?vue&type=script&lang=js&"
export * from "./IntegratedUseCases.vue?vue&type=script&lang=js&"
import style0 from "./IntegratedUseCases.vue?vue&type=style&index=0&id=64d27714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d27714",
  null
  
)

export default component.exports